<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Leave Master
        </div>
        <div class="card-body p-1" style="overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                         <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th scope="col" style="display: none;">Leave Master ID</th>
                        <th scope="col">Leave Name</th>
                        <th scope="col">Leave Type</th>
                        <th scope="col">Gender</th>
                        <th scope="col">Marital Status</th>
                        <th scope="col">Comp Off</th>  
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of LeaveMasterData; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="onEditClick(site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                        <td style="display: none;">{{ site['LeaveMasterID'] }}</td>
                        <td>{{ site['LeaveName'] }}</td>
                        <td>{{ site['LeaveType'] }}</td>
                        <td>{{ site['Gender'] }}</td>
                        <td>{{ site['MaritalStatus'] }}</td>
                        <td>{{ site['IsCompOff'] ? 1 : 0 }}</td>
                    </tr>
                </tbody>
            </table>

        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button (click)="excelDownload()" class="btn btn-primary btn-sm">
                    <i class="bi bi-file-earmark-arrow-down"></i>
                    Excel</button>
                </div>
            </div>
        </div>
    </div>
</div>